export default __webpack_public_path__ + "static/media/leef wolf.150bb073.jpg";